import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import {linkStyleLeftArrow, linkStyleOrange, linkStyleRightArrow} from "../styles/mixins";
import {sidePaddingNormal, verticalPaddingNormal} from "../styles/layouts";


const styles = (theme) => ({
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    marginBottom: theme.spacing.unit * 2,
  },
  linkPrevious: {
    ...linkStyleLeftArrow(theme),
  },
  linkNext: {
    ...linkStyleRightArrow(theme),

  },
  linkBack: {
    ...linkStyleOrange(theme),
  },
  [theme.breakpoints.up('lg')]: {
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    item: {
      marginBottom: 0,
      '&.previous': {
        gridColumn: 1,
      },
      '&.back': {
        gridColumn: 2,
        textAlign: 'center',
      },
      '&.next': {
        gridColumn: 3,
        textAlign: 'right',
      }
    }
  }
});

function Navigator(props) {
  const {classes, backLink, backLabel, previousLink, previousLabel, nextLink, nextLabel} = props;

  return (
    <section className={classes.navigator}>
      <div className={classes.container}>
        <div className={`${classes.item} previous`}>
          {previousLink && <Link className={classes.linkPrevious} to={previousLink}>{previousLabel}</Link>}
        </div>
        <div className={`${classes.item} back`}>
          {backLink && <Link className={classes.linkBack} to={backLink}>{backLabel}</Link>}
        </div>
        <div className={`${classes.item} next`}>
          {nextLink && <Link className={classes.linkNext} to={nextLink}>{nextLabel}</Link>}
        </div>
      </div>
    </section>
  )
}


export default withStyles(styles)(Navigator);



// WEBPACK FOOTER //
// ./src/parts/Navigator.js